module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-05-70944f48b61813e0292c135291870bfa.png";